import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentSection } from '../components/ContentSection';
import { VideoSection } from '../components/VideoSection';
import { BonusSection } from '../components/BonusSection';
import { CertificateSection } from '../components/CertificateSection';
import { OrderBumpSection } from '../components/OrderBumpSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { ClosingSection } from '../components/ClosingSection';
import { FAQSection } from '../components/FAQSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function LandingPage() {
  return <main className="w-full min-h-screen" data-id="element-310">
      <HeroSection data-id="element-311" />
      <ProblemSection data-id="element-312" />
      <SolutionSection data-id="element-313" />
      <ContentSection data-id="element-314" />
      <VideoSection data-id="element-315" />
      <BonusSection data-id="element-316" />
      <CertificateSection data-id="element-317" />
      <OrderBumpSection data-id="element-318" />
      <PricingSection data-id="element-319" />
      <TestimonialsSection data-id="element-320" />
      <ClosingSection data-id="element-321" />
      <FAQSection data-id="element-322" />
      <SocialProofPopup data-id="element-323" />
      <WhatsAppButton data-id="element-324" />
    </main>;
}